import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CogIcon from 'material-ui/svg-icons/content/create';
import OkIcon from 'material-ui/svg-icons/action/done';

import { showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';

//import custom rest client
import { UPDATE } from 'admin-on-rest';
import restClient from '../../restClient';
import TextField from 'material-ui/TextField';



const styles = {
	inlineedit: { width: 21, height: 21, padding: 2, color: '#fd9512', cursor: 'pointer', marginBottom: '-6px', marginLeft: '5px'},
	inlineeditCheck: { width: 26, height: 26, padding: 2, color: '#fd9512', cursor: 'pointer', marginBottom: '-10px', marginLeft: '5px'},
	inlineInputField: { width: 50 },
};



class UpdateCpcButton extends Component {
   	constructor(props){
	    super(props);
    	this.state = { 
			editingOn : false,
			cpc : props.record.bid,
		};
  	}
	
    handleClick = () => {      
	   	this.setState({editingOn:true});	
    }

 	handleSaveClick = () => {
		// const { push, record, showNotification } = this.props;
       const { record, showNotification } = this.props;
       const updateCpcData = { id: record.id, bid: this.state.cpc };
	   
	   if((this.state.cpc % 0.25) !==0 ) {
		   showNotification('ads.bid_stepsize','warning')
	   } else if (record.minimum_cpc > this.state.cpc) {
		   showNotification('ads.min_bid_invalid','warning', {messageArgs:{minbid: record.minimum_cpc}}) 
	   } else {	  
	  		restClient(UPDATE, 'member/updatecpc', {id: record.id, data: updateCpcData} )
			   .then((response) => {
				   record.bid = response.data.bid;
				   record.bid_changed_on = response.data.bid_changed_on
					showNotification('aor.notification.updated','confirm');
					this.setState({editingOn:false});	   
					//push('/member/ads');
				})
				.catch((e) => {
					console.error(e);
					showNotification('cloudhints.error_try_again','warning')
				});
	   }
    }
	
	saveCpcState = (e) => {
		this.setState({cpc: e.target.value})
	}
	
    render() {
       if(this.props.record.user_can_bid === false || this.props.record.user_can_bid === 0) {
		 	return <div key="1">{this.props.record.bid}</div>;	
	   } else if(this.state.editingOn) {
	   		return [ 
				<div key="1">
					<TextField id="cpc-update" value={this.state.cpc} type="number" step="any" style={styles.inlineInputField} onChange={this.saveCpcState} />
					<OkIcon style={styles.inlineeditCheck} onClick={this.handleSaveClick} /></div>
				];
	   }
	   else {
		   return [
				<div key="1">
					<span className='bidContainer'><span className='bidVal'>€ {this.props.record.bid} </span>
					<CogIcon style={styles.inlineedit} onClick={this.handleClick} /> </span>
				</div>,			
			];
	   }
    }
}

UpdateCpcButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(UpdateCpcButton);


// WEBPACK FOOTER //
// ./src/ads/buttons/UpdateCpcButton.js